import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const DotVerticalIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M11 12.3252C11 12.5904 11.1054 12.8448 11.2929 13.0323C11.4804 13.2198 11.7348 13.3252 12 13.3252C12.2652 13.3252 12.5196 13.2198 12.7071 13.0323C12.8946 12.8448 13 12.5904 13 12.3252C13 12.06 12.8946 11.8056 12.7071 11.6181C12.5196 11.4306 12.2652 11.3252 12 11.3252C11.7348 11.3252 11.4804 11.4306 11.2929 11.6181C11.1054 11.8056 11 12.06 11 12.3252Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19.3252C11 19.5904 11.1054 19.8448 11.2929 20.0323C11.4804 20.2198 11.7348 20.3252 12 20.3252C12.2652 20.3252 12.5196 20.2198 12.7071 20.0323C12.8946 19.8448 13 19.5904 13 19.3252C13 19.06 12.8946 18.8056 12.7071 18.6181C12.5196 18.4306 12.2652 18.3252 12 18.3252C11.7348 18.3252 11.4804 18.4306 11.2929 18.6181C11.1054 18.8056 11 19.06 11 19.3252Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 5.3252C11 5.59041 11.1054 5.84477 11.2929 6.0323C11.4804 6.21984 11.7348 6.3252 12 6.3252C12.2652 6.3252 12.5196 6.21984 12.7071 6.0323C12.8946 5.84477 13 5.59041 13 5.3252C13 5.05998 12.8946 4.80563 12.7071 4.61809C12.5196 4.43055 12.2652 4.3252 12 4.3252C11.7348 4.3252 11.4804 4.43055 11.2929 4.61809C11.1054 4.80563 11 5.05998 11 5.3252Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(DotVerticalIcon);
